module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-15.b1e6bed8.svg";